import '../../sass/pages/partners.scss';

const rewardRate = 0.1;
const currencyFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
});

const initPartnerCalculator = (calculator: HTMLElement): void => {
  if (calculator.dataset.calculatorInitialized === 'true') {
    return;
  }

  const range = calculator.querySelector<HTMLInputElement>('[data-partner-project-range]');
  const projectOutput = calculator.querySelector<HTMLOutputElement>('[data-partner-project-output]');
  const rewardOutput = calculator.querySelector<HTMLOutputElement>('[data-partner-reward-output]');

  if (!range || !projectOutput || !rewardOutput) {
    return;
  }

  const updateCalculator = (): void => {
    const amount = Number(range.value);
    const min = Number(range.min);
    const max = Number(range.max);
    const progress = max > min ? ((amount - min) / (max - min)) * 100 : 0;

    projectOutput.value = currencyFormatter.format(amount);
    rewardOutput.value = currencyFormatter.format(Math.round(amount * rewardRate));
    range.style.setProperty('--range-progress', `${progress}%`);
  };

  range.addEventListener('input', updateCalculator);
  calculator.dataset.calculatorInitialized = 'true';
  updateCalculator();
};

document.querySelectorAll<HTMLElement>('[data-partner-calculator]').forEach(initPartnerCalculator);
